// @ts-nocheck
import { Component } from 'react'
import { withRouter } from 'react-router'
import { Device } from '@capacitor/device'
import { isNative } from '../../common/helpers/isNative'
import PropTypes from 'prop-types'

class ScrollToTop extends Component {
  async componentDidUpdate(prevProps) {
    // Scroll to top.
    if (
      this.props.location &&
      this.props.location.pathname !== '/login' &&
      this.props.location.pathname !== prevProps.location.pathname
    ) {
      const clientWidth = document.documentElement.clientWidth
      if (clientWidth < 992) {
        const content = document.getElementsByClassName('layout__content')
        if (content[0]) {
          content[0].scrollTop = 0
        }
      } else {
        window.scrollTo(0, 0)
      }
      let isIos12 = false
      if (isNative()) {
        const info = await Device.getInfo()
        isIos12 = info.platform === 'ios' && Math.floor(parseFloat(info.osVersion)) === 12
      }
      // This is needed for iOS 12 blank screen bug fix.
      if (isIos12) {
        const content = document.getElementsByClassName('layout__content')
        if (content[0]) {
          content[0].classList.remove('scrollable')
          setTimeout(function () {
            content[0].classList.add('scrollable')
          }, 32)
        }
      }
    }
  }

  render() {
    return this.props.children
  }
}
ScrollToTop.propTypes = {
  location: PropTypes.object.isRequired,
  children: PropTypes.object.isRequired,
}

export default withRouter(ScrollToTop)
